import { OwnerSimplifiedDto } from '../owner/owner-simplified.dto';

export class ListFamilyDto {
  owners: OwnerSimplifiedDto[];

  constructor(owners: OwnerSimplifiedDto[]) {
    this.owners = owners;
  }
}
